module.exports = __webpack_public_path__ + "static/media/hybris.672ae1e2.jpeg";